export default __webpack_public_path__ + "static/media/bonnet.aaaf3e8c.jpg";